import { GetterTree } from "vuex";
import { AuthState } from "./state";

export const getters: GetterTree<AuthState, any> = {
  getUser: (state) => state.user,
  getToken: (state) => state.token,
  isAuthenticated: (state) => state.isAuthenticated,
  hasPermission: (state) => (permission: string) => {
    return state.user?.permissions?.includes(permission) || false;
  },
};
